import React, { useEffect } from "react";

import {
  Box,
  Pressable,
  Heading,
  VStack,
  HStack,
  IconButton,
} from "native-base";
import Theme from "../../argon-ui/Theme";
import Text from "../TextFont";
import FontAwesomeIcon from "../FontAwesomeIcon";
import { faTimes } from "../../../assets/consts/faCharCodes";
import {
  Animated,
  Easing,
  StyleSheet,
  TouchableHighlight,
  View,
} from "react-native";
import { IS_MOBILE } from "../../locales/translate";
import { APP_VERSION } from "../../../assets/consts";
import { ScrollView } from "react-native-gesture-handler";
import { getIsRTL } from "../../util";
// const Drawer = createDrawerNavigator();
type Props = {
  tabs: any;
  navigation: any;
  buildingName: string;
  userFullName: string;
  onClose: () => void;
};
interface TabType {
  label: string;
  icon: string;
  callback: () => void;
  badge?: boolean;
  badgeNumber?: number;
}
interface MenuItemPropsType {
  tab: TabType;
  onClose?: () => void;
}
const MenuDrawer = (props: Props) => {
  const { onClose, buildingName, tabs, navigation, userFullName } = props;
  const width = new Animated.Value(0);
  const maxWidth = width.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 320], // <-- any value larger than your content's height
  });
  // useEffect(() => {
  //   let timeoutId = setTimeout(() => {}, 80);
  //   return () => {
  //     clearTimeout(timeoutId);
  //   };
  // }, []);
  Animated.timing(width, {
    toValue: 1,
    duration: 100, // <-- animation duration
    easing: Easing.linear, // <-- or any easing function
    useNativeDriver: false, // <-- need to set false to prevent yellow box warning
  }).start();

  return (
    <Box style={styles.wrapper}>
      <Animated.View style={[styles.menuContainer, { maxWidth: maxWidth }]}>
        {/* === Header === */}
        <VStack
          space="2"
          style={{ marginVertical: 10 }}
          textAlign={getIsRTL() ? "right" : "left"}
        >
          <Heading style={{ fontSize: 16, overflow: "hidden" }}>
            {buildingName}
          </Heading>
          {userFullName && userFullName.length !== 0 && (
            <Text
              style={{
                fontWeight: "bold",
                fontSize: 11,
                color: Theme.COLORS.GRAY_DARK,
              }}
            >
              {userFullName}
            </Text>
          )}
        </VStack>
        <IconButton
          alignSelf="center"
          position="absolute"
          top="20px"
          variant="ghost"
          style={[
            styles.closeIcon,
            IS_MOBILE || !getIsRTL() ? { right: 20 } : { left: 20 },
          ]}
          onPress={() => onClose()}
          icon={
            <FontAwesomeIcon
              icon={faTimes}
              size={14}
              color={Theme.COLORS.MUTED}
            />
          }
        />
        {/* </HStack> */}
        {/* <VStack mt="5"> */}
        <ScrollView>
          {(tabs || []).map((tab: any, i: number) => {
            return (
              <Box
                py="3"
                style={
                  i !== tabs.length - 1 && {
                    borderBottomWidth: 1,
                    borderBottomColor: "#f1f1f3",
                  }
                }
                key={i}
              >
                {tab?.tabItem.map((tab: any, index: number) => {
                  if (tab.hide !== undefined && !tab.hide) {
                    return null;
                  }
                  return <MenuItem key={index} tab={tab} onClose={onClose} />;
                })}
              </Box>
            );
          })}
        </ScrollView>
        {/* </VStack> */}
        <TouchableHighlight
          underlayColor="transparent"
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            left: 0,
          }}
          onPress={() => {
            if (IS_MOBILE) {
              navigation.navigate("Updates");
              onClose();
            }
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Text
              style={{
                textAlign: "center",
                fontSize: 10,
                padding: 10,
                color: Theme.COLORS.MUTED,
                alignSelf: "center",
              }}
              onPress={() => {
                if (IS_MOBILE) {
                  navigation.navigate("Updates");
                  onClose();
                }
              }}
            >
              version: {APP_VERSION}
            </Text>
          </View>
        </TouchableHighlight>
      </Animated.View>
      {/* === backdrop === */}
      <TouchableHighlight
        underlayColor="#00000091"
        onPress={() => onClose()}
        style={styles.backdrop}
      >
        <View />
      </TouchableHighlight>
    </Box>
  );
};

const MenuItem = ({ tab, onClose }: MenuItemPropsType) => {
  const COLOR_TEXT = "#6e6e6e";
  return (
    <Pressable
      px="2"
      py="2"
      mb="2"
      onPress={() => {
        tab.callback();
        typeof onClose === "function" && onClose();
      }}
    >
      <HStack alignItems="center" justifyContent="space-between">
        <HStack space="5" alignItems="center">
          <Box alignItems="center">
            {/* === small badge === */}
            {tab?.badge && <View style={styles.smallBadge} />}

            {/* === Icon === */}
            <FontAwesomeIcon icon={tab.icon} size={18} color={COLOR_TEXT} />
          </Box>
          <Text style={[styles.menuItemText, { color: COLOR_TEXT }]}>
            {tab.label}
          </Text>
        </HStack>
        {/* === Badge === */}
        {Boolean(tab?.badgeNumber) && (
          <Box style={styles.badgeNumberContainer}>
            <Text style={styles.badgeNumberText}>{tab.badgeNumber}</Text>
          </Box>
        )}
      </HStack>
    </Pressable>
  );
};
const styles = StyleSheet.create({
  wrapper: {
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    zIndex: 999,
  },
  backdrop: {
    backgroundColor: "#0000008c",
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    zIndex: -1,
  },
  menuItemText: {
    fontSize: 14,
  },
  menuContainer: {
    backgroundColor: Theme.COLORS.WHITE,
    padding: 20,
    height: "100%",
    overflow: "hidden",
    position: "relative",
  },
  closeIcon: {
    width: 35,
    height: 35,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    backgroundColor: Theme.COLORS.WHITE,
    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
  smallBadge: {
    width: 6,
    height: 6,
    backgroundColor: Theme.COLORS.BADGE,
    borderRadius: 3,
    position: "absolute",
    top: -6,
    right: -8,
  },
  badgeNumberContainer: {
    width: 25,
    height: 25,
    backgroundColor: Theme.COLORS.BADGE,
    borderRadius: 5,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: Theme.COLORS.BADGE,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
  badgeNumberText: {
    color: Theme.COLORS.WHITE,
  },
});
export default MenuDrawer;
